module.exports = __webpack_public_path__ + "img/shopping-bag.0fcec83b.svg";